import PropTypes from 'prop-types'

const CompactStats = ({ items, className = '' }) => {
  return (
    <div
      className={`flex w-full flex-col divide-y divide-gray-200 overflow-hidden rounded-lg border border-gray-200 bg-gray-50 sm:w-fit sm:flex-row sm:divide-x sm:divide-y-0 ${className}`.trim()}
    >
      {items.map((item, index) => (
        <div key={index} className='flex items-center gap-x-2.5 px-4 py-3'>
          <item.icon
            className='h-4 w-4 shrink-0 text-blue-500'
            aria-hidden='true'
          />
          <div>
            <p className='text-xs text-gray-400'>{item.name}</p>
            <p className='text-sm font-semibold text-gray-900'>{item.stat}</p>
          </div>
        </div>
      ))}
    </div>
  )
}

CompactStats.propTypes = {
  className: PropTypes.string,
  items: PropTypes.arrayOf(
    PropTypes.shape({
      icon: PropTypes.elementType.isRequired,
      name: PropTypes.string.isRequired,
      stat: PropTypes.oneOfType([PropTypes.string, PropTypes.node]).isRequired
    })
  ).isRequired
}

export default CompactStats
